<template>
  <header class="headTab">
    <nav>
      <section class="tab">
        <!--        <img class="logo" src="../../assets/img/logo.png" alt="">-->
        <div class="logo">
          <!-- <span class="icon"><img src="https://static.iyw.cn/logo/appAbout.png" alt=""></span> -->
          <span class="icon" @click="JumpFun('VUE_APP_INDEX_URL')">
            <img src="../../assets/img/spaceAvatar.png" alt="" />
          </span>
          <span class="name" @click.stop="unfoldMenu = !unfoldMenu"
            >{{ myInfoData.orgInfo.name
            }}<i :class="['el-icon-arrow-down', { up: unfoldMenu }]"></i
          ></span>
          <transition name="el-zoom-in-top">
            <div class="mainMenu" v-show="unfoldMenu">
              <p
                class="label"
                v-if="myInfoData.orgList.some((item) => item.orgFlag <= 1)"
              >
                个人：
              </p>
              <div
                class="mainList mainList-1"
                v-for="item in myInfoData.orgList.filter(
                  (el) => el.orgFlag <= 1
                )"
                :key="item.orgCode"
              >
                <div
                  :class="[
                    'mainList-info',
                    { active: item.orgCode === myInfoData.orgInfo.orgCode },
                  ]"
                  @click.stop="selectMain(item)"
                >
                  <img v-if="item.logo" :src="host + item.logo" />
                  <img v-else src="../../assets/img/avatar.png" alt="" />
                  <div class="name">{{ item.name }}</div>
                  <i class="el-icon-check"></i>
                </div>
              </div>
              <p
                class="label"
                v-if="myInfoData.orgList.some((item) => item.orgFlag === 2)"
              >
                企业：
              </p>
              <div
                class="mainList mainList-2"
                v-for="item in myInfoData.orgList.filter(
                  (el) => el.orgFlag === 2
                )"
                :key="item.orgCode"
              >
                <div
                  :class="[
                    'mainList-info',
                    { active: item.orgCode === myInfoData.orgInfo.orgCode },
                  ]"
                  @click.stop="selectMain(item)"
                >
                  <img v-if="item.logo" :src="host + item.logo" />
                  <img v-else src="../../assets/img/avatar.png" alt="" />
                  <div class="name">{{ item.name }}</div>
                  <span class="we" v-if="item.isOwnCreate == 1">我的</span>
                  <i class="el-icon-check"></i>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <ul>
          <li><a :href="helpCenter" target="_blank">帮助中心</a></li>
          <li><a :href="userAgreement" target="_blank">用户协议</a></li>
          <li><a :href="privacyAgreement" target="_blank">隐私协议</a></li>
        </ul>
      </section>
      <el-button
        class="homePage"
        size="small"
        type="primary"
        @click="JumpFun('VUE_APP_PORTAL')"
        >回到首页</el-button
      >
    </nav>
  </header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { switchBody } from "../../api/accountManage";
export default {
  name: "headNav",
  props: {
    msg: String,
    host: String,
  },
  data() {
    return {
      unfoldMenu: false,
    };
  },
  computed: {
    ...mapGetters([
      "helpCenter",
      "userAgreement",
      "privacyAgreement",
      "myInfoData",
    ]),
  },
  methods: {
    JumpFun(str) {
      window.location.href = process.env[str];
    },
    ...mapActions(["logout", "ProductToken"]),
    closeMenu() {
      this.unfoldMenu = false;
    },
    // 选择主体
    selectMain(item) {
      if (item.status === 0) {
        this.$alert(`您已被${item.name}停用，请选择其他主体`, "停用提示", {
          confirmButtonText: "确定",
          callback: () => {},
        });
        return;
      }
      if (this.myInfoData.orgInfo.orgCode === item.orgCode) {
        this.unfoldMenu = false;
        return;
      }
      this.$confirm(
        `切换到${item.orgFlag === 2 ? "企业" : "个人空间"}（${item.name}）?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0)",
        });
        let { code } = await switchBody({ orgCode: item.orgCode });
        loading.close();
        if (code === 1) {
          await this.ProductToken(); // 更新供应链token
          window.location.href = process.env.VUE_APP_INDEX_URL;
        } else {
          this.$message.error("切换失败~");
        }
      });
    },
  },
  mounted() {
    window.addEventListener("click", this.closeMenu);
  },
  destroyed() {
    window.removeEventListener("click", this.closeMenu);
  },
};
</script>

<style scoped lang="scss">
.headTab {
  height: 80px;
  background: #fff;
  img {
    width: 100%;
    height: auto;
  }
  nav {
    height: 100%;
    width: 1200px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tab {
      height: 100%;
      display: flex;
      align-items: center;
      .logo {
        display: flex;
        align-items: center;
        position: relative;
        .icon {
          width: 38px;
          height: 38px;
          margin-right: 8px;
          display: inline-flex;
          align-items: center;
          cursor: pointer;
        }
        .name {
          font-size: 16px;
          color: #000533;
          cursor: pointer;
          i {
            margin-left: 9px;
            color: #9da1ac;
            font-weight: 600;
            transform: rotate(0deg);
            transition: all 0.3s;
          }
          .up {
            transform: rotate(180deg);
          }
        }
        .mainMenu {
          text-align: left;
          padding: 20px 32px 30px 38px;
          position: absolute;
          width: 296px;
          top: 50px;
          left: 40px;
          background: #ffffff;
          box-shadow: 0 2px 12px 8px rgba(49, 97, 254, 0.05);
          border-radius: 2px;
          .label {
            font-size: 14px;
            font-weight: 400;
            color: #222222;
          }
          .mainList {
            .mainList-info {
              position: relative;
              height: 48px;
              margin-top: 10px;
              line-height: 48px;
              padding: 0 0 0 8px;
              cursor: pointer;
              border-radius: 4px;
              display: flex;
              align-items: center;
              img {
                width: 24px;
                height: 24px;
                margin-right: 10px;
              }
              .name {
                max-width: 140px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                color: #222222;
              }
              .el-icon-check {
                display: none;
              }
            }
            .active {
              background: #f0f3f9;
              position: relative;
              .we {
                background: #80d364;
                border-radius: 2px;
                font-size: 12px;
                font-weight: 400;
                color: #ffffff;
                line-height: 18px;
                padding: 0 4px;
                margin-left: 5px;
              }
              .el-icon-check {
                position: absolute;
                right: -18px;
                top: calc(50% - 8px);
                color: #2e5cf7;
                font-size: 16px;
                font-weight: 600;
                display: inline-block;
              }
            }
          }
          .mainList-1 {
            margin-bottom: 9px;
          }
          .mainList-2 {
            margin-top: 9px;
          }
        }
      }
      ul {
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 16px;
        color: $textColor;
        li {
          margin: 0 25px;
          cursor: pointer;
          a {
            color: $textColor;
          }
        }
      }
    }
    .homePage {
      width: 84px;
    }
  }
}
</style>
